/**
 * @generated SignedSource<<102db6648c5d2b489f7146fe16c60e8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePageInput = {
  clientMutationId?: string | null;
  messageDefinitionId: string;
  pageId: string;
};
export type useMessagePageMutations_DeletePageMutation$variables = {
  input: DeletePageInput;
};
export type useMessagePageMutations_DeletePageMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly deletePage: {
        readonly messageDefinition: {
          readonly id: string;
        };
      } | null;
    };
  };
};
export type useMessagePageMutations_DeletePageMutation = {
  response: useMessagePageMutations_DeletePageMutation$data;
  variables: useMessagePageMutations_DeletePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageDefinitionsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "MessageDefinitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "DeletePagePayload",
            "kind": "LinkedField",
            "name": "deletePage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDefinition",
                "kind": "LinkedField",
                "name": "messageDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageMutations_DeletePageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMessagePageMutations_DeletePageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99b1e29e27f9e6fc51e47a5ad9e67169",
    "id": null,
    "metadata": {},
    "name": "useMessagePageMutations_DeletePageMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageMutations_DeletePageMutation(\n  $input: DeletePageInput!\n) {\n  Admin {\n    MessageDefinitions {\n      deletePage(input: $input) {\n        messageDefinition {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d957e26703bbeab761d71aeb55aa94b";

export default node;
